import { MainPhotoSection } from "../MainPage/MainPageStyles";
import {
  AdvantagesWorkongSection,
  OmniTradersSection,
} from "./AboutUsPageStyles";
import { AccessibleMarketsSections } from "../MarketsPage/MarketPageStyles";
import AboutUsMainPhoto from "../../images/aboutUsMainPhoto.png";
import { MSectionCard } from "../../components/SectionCard/SectionCard";
import Card1Img from "../../images/AboutUs/card1.png";
import Card2Img from "../../images/AboutUs/card2.png";
import Card3Img from "../../images/AboutUs/card3.png";
import Card4Img from "../../images/AboutUs/card4.png";
import { MAboutUsCard } from "../../components/Cards/AboutUsCard/AboutUsCard";
import { Link } from "react-router-dom";
import AboutUsBigPhoto from "../../images/AboutUs/mainImage.png";
import { MCardWithImgAndTitle } from "../../components/Cards/CardWithImgAndTitle/CardWithImgAndTitle";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
  arrAnimationFromTheSide,
  mainAnimation,
} from "../../animations/animations";
import Stock from "../../images/CardsImages/MarketsCardsIcons/stock.svg";
import Commod from "../../images/CardsImages/MarketsCardsIcons/commodities.svg";
import Index from "../../images/CardsImages/MarketsCardsIcons/index.svg";
import Forex from "../../images/CardsImages/MarketsCardsIcons/forex.svg";
import Crypto from "../../images/CardsImages/MarketsCardsIcons/crypto.svg";
import FirstSectionPhoto from "../../images/AboutUs/firstSectionImg.webp";
import SecondSectionPhoto from "../../images/AboutUs/secondSection.jpg";
import { useTranslation } from "react-i18next";

export const AboutUsPage = () => {
  const { t } = useTranslation();

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("aboutUsPage.title1")}</h1>
            <p className="big__text">{t("aboutUsPage.title2")}</p>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={AboutUsMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <AdvantagesWorkongSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("aboutUsPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="advantages-section__content flex__between"
          >
            <motion.div className="left__side">
              <MAboutUsCard
                img={Card1Img}
                title={`${t("aboutUsPage.blockInfo111")}`}
                text={`${t("aboutUsPage.blockInfo112")}`}
                background="#005c32db"
                width="49%"
                custom={1}
                variants={arrAnimation}
                key={"aboutCard1"}
              />
              <MAboutUsCard
                img={Card2Img}
                title={`${t("aboutUsPage.blockInfo121")}`}
                text={`${t("aboutUsPage.blockInfo122")}`}
                background="#687b00e0"
                width="49%"
                custom={2}
                variants={arrAnimation}
                key={"aboutCard2"}
              />
              <MAboutUsCard
                img={Card3Img}
                title={`${t("aboutUsPage.blockInfo131")}`}
                text={`${t("aboutUsPage.blockInfo132")}`}
                background="#001c62e0"
                width="100%"
                custom={3}
                variants={arrAnimation}
                key={"aboutCard3"}
              />
            </motion.div>
            <motion.div className="right__side">
              <MAboutUsCard
                img={Card4Img}
                title={`${t("aboutUsPage.blockInfo141")}`}
                text={`${t("aboutUsPage.blockInfo142")}`}
                background="#001c62e0"
                width="100%"
                custom={4}
                variants={arrAnimation}
                key={"aboutCard4"}
              />
            </motion.div>
          </motion.div>
        </div>
      </AdvantagesWorkongSection>
      <OmniTradersSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart"
        >
          <motion.h2 custom={1} variants={arrAnimationFromTheSide}>
            {t("aboutUsPage.blockInfo2Tit")}
          </motion.h2>
          <motion.p
            custom={2}
            variants={arrAnimationFromTheSide}
            className="big__text"
          >
            {t("aboutUsPage.blockInfo21")}
          </motion.p>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={mainAnimation}
            className="main__container"
            style={{
              backgroundImage: `url(${AboutUsBigPhoto})`,
            }}
          >
            <div className="top card__settings flex__between">
              <div>
                <h2>{t("aboutUsPage.blockInfo311")}</h2>
                <span></span>
                <p>{t("aboutUsPage.blockInfo312")}</p>
              </div>
              <div>
                <h2>{t("aboutUsPage.blockInfo321")}</h2>
                <span></span>
                <p>{t("aboutUsPage.blockInfo322")}</p>
              </div>
            </div>
            <div className="bottom card__settings flex__between">
              <div>
                <h2>{t("aboutUsPage.blockInfo331")}</h2>
                <span></span>
                <p>{t("aboutUsPage.blockInfo332")}</p>
                <Link to="/" className="white__button flex__center">
                  {t("aboutUsPage.blockInfo333")}
                </Link>
              </div>
              <div>
                <h2>{t("aboutUsPage.blockInfo341")}</h2>
                <span></span>
                <p>{t("aboutUsPage.blockInfo342")}</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </OmniTradersSection>
      <AccessibleMarketsSections>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart"
        >
          <motion.h2 variants={animationFromTheSide}>
            Accessible Markets.
          </motion.h2>
          <motion.div className="cards__container">
            <MCardWithImgAndTitle
              custom={1}
              variants={arrAnimation}
              img={Stock}
              title={`${t("aboutUsPage.blockInfo41")}`}
              width="49%"
              key={"aboutCardWithImg1"}
            />
            <MCardWithImgAndTitle
              custom={2}
              variants={arrAnimation}
              img={Commod}
              title={`${t("aboutUsPage.blockInfo42")}`}
              width="49%"
              key={"aboutCardWithImg2"}
            />
            <MCardWithImgAndTitle
              custom={3}
              variants={arrAnimation}
              img={Index}
              title={`${t("aboutUsPage.blockInfo43")}`}
              width="32%"
              key={"aboutCardWithImg3"}
            />
            <MCardWithImgAndTitle
              custom={4}
              variants={arrAnimation}
              img={Crypto}
              title={`${t("aboutUsPage.blockInfo44")}`}
              width="32%"
              key={"aboutCardWithImg4"}
            />
            <MCardWithImgAndTitle
              custom={5}
              variants={arrAnimation}
              img={Forex}
              title={`${t("aboutUsPage.blockInfo45")}`}
              width="32%"
              key={"aboutCardWithImg5"}
            />
          </motion.div>
        </motion.div>
      </AccessibleMarketsSections>
      <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={{ amount: 0.3, once: true }}
      >
        <MSectionCard
          custom={1}
          variants={arrAnimation}
          link={true}
          background="#001b48"
          title={`${t("aboutUsPage.blockInfo51")}`}
          text={`${t("aboutUsPage.blockInfo52")}`}
          img={FirstSectionPhoto}
          key={"aboutSectionCard1"}
        />
        <MSectionCard
          custom={2}
          variants={arrAnimation}
          flexDirection="row-reverse"
          right="0"
          left="auto"
          link={true}
          background="rgb(40 117 141)"
          title={`${t("aboutUsPage.blockInfo53")}`}
          img={SecondSectionPhoto}
          key={"aboutSectionCard2"}
        />
      </motion.section>
    </main>
  );
};
